import { Checkbox } from "@mui/material";
import { DefaultValuesDto } from "../../common/defaultValues";
import { EntityStore, UseEntityStore } from "../../common/entityStore";
import { formatNumber } from "../../common/localization";
import { ShipmentDetailDto } from "../../common/order";
import { MailOrderEditDto } from "./types";
import { keyBy } from "lodash";
import { OrderStateId } from "../../common/enum";

export function ShipmentAutoQuantity(props: { useStore: UseEntityStore<MailOrderEditDto>; auto: ShipmentDetailDto; def: EntityStore<DefaultValuesDto>; updateOrder(): void; }) {
    function toggle() {
        const autos = props.useStore.getState().clientData.autos;
        const otherAutosInGroupDict = keyBy(props.auto.otherAutosInGroup ?? []);
        props.useStore.getState().setClientDataProp("autos", autos.map(p =>
            p.saleArticleId === props.auto.saleArticleId ? { ...p, quantity: p.quantity > 0 ? 0 : p.quantityWhenSelected!, autoSelect: p.quantity === 0 } :
                otherAutosInGroupDict[p.projectMailOrderConditionId!] != null ? { ...p, quantity: 0, autoSelect: false } :
                    p));
        props.updateOrder();
    }
    const { editable, isEditing } = props.useStore(p => ({ editable: p.clientData.orderStateId !== OrderStateId.Shipped, isEditing: p.clientData.isEditing }));
    return <>{editable && props.auto.missingAmount === 0 && isEditing && <Checkbox checked={props.auto.quantity !== 0} onChange={toggle} />} {formatNumber(props.auto.quantity, props.def.clientData.landCode, false)}</>;
}
